// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HNHi","left":"styles_left__MWRDh"};